module.exports = __webpack_public_path__ + "img/ic_tuyun_icon.0bcb3b57.png";